@if (loggedIn()) {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <mat-spinner class="m-2" color="primary" [diameter]="96"></mat-spinner>
    <label class="m-2">Signing out...</label>
  </div>
} @else {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <div>You have been signed out.</div>
    <button modus-flat-button color="primary" (click)="login()">Sign in</button>
  </div>
}
